import { render, staticRenderFns } from "./WarrantyClaimContainer.vue?vue&type=template&id=556262a0&"
import script from "./WarrantyClaimContainer.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports